export const environment = {
  production: false,
  stripe_token: "STRIPE_TOKEN",
  paypal_token: "PAYPAL_TOKEN",
  baseUrl: "https://erp.gerenciarsc.com.br/api/",
  //baseUrl: "https://localhost:44356/",
  idEmpresa: "11",
};